<template>
  <CompanyCrudTable />
</template>

<script>
import CompanyCrudTable from '@/components/table/CompanyCrudTable.vue';

export default {
  name: 'CompaniesPage',
  components: {
    CompanyCrudTable
  }
};
</script>

<style scoped>
.v-card {
  margin: 16px;
}
</style>
